import React from "react";
import { TextField } from '@rmwc/textfield';
import {
  DialogTitle,
  DialogContent
} from '@rmwc/dialog';

import '@material/dialog/dist/mdc.dialog.css';
import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';

class SerialNum extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      serialnum: props.serialnum,
    };

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    this.setState({
      serialnum: {
        ...this.state.serialnum,
        number: event.target.value,
      },
    }, () => {
      this.props.onChange(this.state.serialnum);
    });
  }
  render() {
    return (
      <div>
        <DialogTitle>Shaft serial number</DialogTitle>
        <DialogContent style={{paddingTop: '15px'}}>
          <TextField
            style={{width: '100%'}}
            outlined
            label="Serial number"
            value={this.state.serialnum.number}
            onChange={(event) => this.handleChange(event)}/>
        </DialogContent>
      </div>
    );
  };
};

export default SerialNum;